module.exports = {
  logged: function (state) {
    return state.logged
  },
  user: function (state) {
    return state.user
  },
  auth: function (state) {
    return state.auth
  },
  active: function (state) {
    return state.active
  },
  language: function (state) {
    return state.language
  }
}



// WEBPACK FOOTER //
// ./src/common/store/getters.js